export const dashboardOrderStatuses = {
  all: 'ALL',
  closed: 'CLOSED',
  open: 'OPEN',
}
